import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  exportClientDeviceByDay,
  exportClientDeviceByRangeDay,
  exportTotalClientDeviceByRangeDay,
  getClientDeviceByDay,
  getClientDeviceByRangeDay,
  getTotalClientDeviceByRangeDay,
} from '@/apis/clientDevice'
import { apiHost } from '@/configs/api'
import useNotification from '@/hooks/useNotification'
import {
  ExportClientDeviceByDayRequest,
  ExportClientDeviceByRangeDayRequest,
  ExportTotalClientDeviceByRangeDayRequest,
  GetClientDeviceByDayRequest,
  GetClientDeviceByDayResponse,
  GetClientDeviceByRangeDayRequest,
  GetClientDeviceByRangeDayResponse,
  GetTotalClientDeviceByRangeDayRequest,
  GetTotalClientDeviceByRangeDayResponse,
} from '@/types/apis/clientDevice'

export const useClientDeviceByDay = () => {
  const openNotification = useNotification()
  const { t } = useTranslation()
  const [responseClientDevice, setResponseClientDevice] = useState<GetClientDeviceByDayResponse>()
  const [responseClientDeviceLoading, setResponseClientDeviceLoading] = useState(false)
  const [exportClientDeviceLoading, setExportClientDeviceLoading] = useState(false)
  const [exportClientDeviceByDayLoading, setExportClientDeviceByDayLoading] = useState(false)
  const [exportClientDeviceByRangeDayLoading, setExportClientDeviceByRangeDayLoading] = useState(false)
  const [responseClientDeviceByRangeDay, setResponseClientDeviceByRangeDay] =
    useState<GetClientDeviceByRangeDayResponse>()
  const [responseClientDeviceByRangeDayLoading, setResponseClientDeviceByRangeDayLoading] = useState(false)
  const [responseTotalClientDevice, setResponseTotalClientDevice] = useState<GetTotalClientDeviceByRangeDayResponse>()
  const [responseTotalClientDeviceLoading, setResponseTotalClientDeviceLoading] = useState(false)

  const get = useCallback(async (request: GetClientDeviceByDayRequest) => {
    try {
      setResponseClientDeviceLoading(true)
      const res = await getClientDeviceByDay(request)
      setResponseClientDevice(res)
    } finally {
      setResponseClientDeviceLoading(false)
    }
  }, [])

  const exportExcel = async (request: ExportClientDeviceByDayRequest) => {
    // TODO: call API and open url in a new tab
    try {
      setExportClientDeviceLoading(true)
      const result = await exportClientDeviceByDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
      // TODO:
    } finally {
      setExportClientDeviceLoading(false)
    }
  }

  const getClientByRangeDay = useCallback(
    async (request: GetClientDeviceByRangeDayRequest) => {
      try {
        setResponseClientDeviceByRangeDayLoading(true)
        const res = await getClientDeviceByRangeDay(request)
        setResponseClientDeviceByRangeDay(res)
      } catch {
        openNotification({
          type: 'error',
          description: t('components.pages.clientDevice.listReport.hooks.selectRangeDateFail'),
        })
      } finally {
        setResponseClientDeviceByRangeDayLoading(false)
      }
    },
    [openNotification, t]
  )

  const exportExcelByRangeDay = async (request: ExportClientDeviceByRangeDayRequest) => {
    try {
      setExportClientDeviceByDayLoading(true)
      // TODO: call API and open url in a new tab
      const result = await exportClientDeviceByRangeDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
      // TODO:
    } finally {
      setExportClientDeviceByDayLoading(false)
    }
  }

  const getTotalClientByRangeDay = useCallback(
    async (request: GetTotalClientDeviceByRangeDayRequest) => {
      try {
        setResponseTotalClientDeviceLoading(true)
        const res = await getTotalClientDeviceByRangeDay(request)
        setResponseTotalClientDevice(res)
      } catch {
        openNotification({
          type: 'error',
          description: t('components.pages.clientDevice.listReport.hooks.selectRangeDateFail'),
        })
      } finally {
        setResponseTotalClientDeviceLoading(false)
      }
    },
    [openNotification, t]
  )

  const exportExcelTotalClientByRangeDay = async (request: ExportTotalClientDeviceByRangeDayRequest) => {
    try {
      setExportClientDeviceByRangeDayLoading(true)
      // TODO: call API and open url in a new tab
      const result = await exportTotalClientDeviceByRangeDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
    } finally {
      setExportClientDeviceByRangeDayLoading(false)
    }
  }

  return {
    getClientDeviceByDay: get,
    getClientDeviceByRangeDay: getClientByRangeDay,
    getTotalClientByRangeDay,
    exportExcelClientDeviceByDay: exportExcel,
    exportExcelByRangeDay,
    exportExcelTotalClientByRangeDay,
    responseClientDevice,
    responseClientDeviceByRangeDay,
    responseTotalClientDevice,
    responseClientDeviceLoading,
    responseClientDeviceByRangeDayLoading,
    responseTotalClientDeviceLoading,
    exportClientDeviceLoading,
    exportClientDeviceByDayLoading,
    exportClientDeviceByRangeDayLoading,
  }
}
